module.exports = __webpack_public_path__ + "static/media/default-profile-header.18714c1a.png";